import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import Comments from '../components/Comments';
import '../css.css';

const HEADERS = [
  { key: 'lv', label: '레벨' },
  { key: 'exp', label: '경험치' },
  { key: 'exp_total', label: '누적 경험치' },
  { key: 'sp', label: '스킬 포인트' },
  { key: 'sp_total', label: '누적 스킬포인트' },
  { key: 'note', label: '비고' },
];

const Page1 = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetch('/api/xptable');
        if (!res.ok) throw new Error('데이터를 불러올 수 없습니다');
        const rows = await res.json();
        setData(rows);
      } catch (e) {
        console.error('Error fetching xptable data:', e);
        setData([]);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <>
      <h1 className="page-title">레벨별 경험치 정보</h1>
      <div className="skill-container">
        {loading ? (
          <div className="spinner-container">
            <LoadingSpinner
              height={80}
              width={80}
              color="#4fa94d"
              visible={true}
            />
          </div>
        ) : (
          <div className="page-content">
            <table className="oil-table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  {HEADERS.map((header) => (
                    <th key={header.key}>{header.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((row, idx) => (
                  <tr key={row.id || idx}>
                    {HEADERS.map((header) => (
                      <td key={header.key}>
                        {row[header.key] || ''}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <Comments pageName="xptable" />
    </>
  );
};

export default Page1;